(function () {
    'use strict';

    angular.module("imApp").factory("checkListItemTwsService", ['$ihttp', function ($ihttp) {
        let service = {
            getLinkToForm: function (parms) {
                return $ihttp.post({
                    method: 1565,
                    parameters: parms || {}
                });
            },
            listLinksToForms: function (parms) {
                return $ihttp.post({
                    method: 1570,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
